/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface LeaderboardEntryEntity
 */
export interface LeaderboardEntryEntity {
    /**
     * 
     * @type {number}
     * @memberof LeaderboardEntryEntity
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardEntryEntity
     */
    firstParticipationUserName?: string;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardEntryEntity
     */
    firstParticipationUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardEntryEntity
     */
    averageScore?: number;
}

/**
 * Check if a given object implements the LeaderboardEntryEntity interface.
 */
export function instanceOfLeaderboardEntryEntity(value: object): boolean {
    return true;
}

export function LeaderboardEntryEntityFromJSON(json: any): LeaderboardEntryEntity {
    return LeaderboardEntryEntityFromJSONTyped(json, false);
}

export function LeaderboardEntryEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardEntryEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'] == null ? undefined : json['position'],
        'firstParticipationUserName': json['firstParticipationUserName'] == null ? undefined : json['firstParticipationUserName'],
        'firstParticipationUserId': json['firstParticipationUserId'] == null ? undefined : json['firstParticipationUserId'],
        'averageScore': json['averageScore'] == null ? undefined : json['averageScore'],
    };
}

export function LeaderboardEntryEntityToJSON(value?: LeaderboardEntryEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'position': value['position'],
        'firstParticipationUserName': value['firstParticipationUserName'],
        'firstParticipationUserId': value['firstParticipationUserId'],
        'averageScore': value['averageScore'],
    };
}

